import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import type { JSX } from 'react';
import { styles } from './SearchField.styles';
import type { SearchFieldProps } from './types';

export const SearchField = ({ query, setQuery, placeholder, open, handleToggle }: SearchFieldProps): JSX.Element => {
  return (
    <TextField
      name="district-search"
      fullWidth
      size="small"
      value={query}
      placeholder={placeholder}
      onChange={e => setQuery(e.target.value)}
      onClick={() => !open && handleToggle()}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {query && (
                  <Box
                    component="span"
                    sx={styles.clearButton}
                    onClick={e => {
                      e.stopPropagation();
                      setQuery('');
                    }}
                  >
                    <Typography variant="body2" component="span" sx={styles.clearButtonText}>
                      ×
                    </Typography>
                  </Box>
                )}
                <KeyboardArrowDownIcon data-test="keyboard-arrow-down-icon" sx={styles.arrowIcon(open)} />
              </Box>
            </InputAdornment>
          ),
          sx: styles.inputProps(open),
        },
      }}
    />
  );
};
